// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yxyweb/client/styles/default/tab.less
// module id = 3217
// module chunks = 0